/* WILD DYNAMICS — Calisthenics Level Wizard (controller/UI)
   Requires: wd-wizard-scoring.js
*/
(function(){
  // ---------- tiny utils ----------
  const $ = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));
  const num = (id) => +$(id.startsWith('#')?id:`#${id}`).value || 0;
  const lang = () => document.documentElement.lang || 'en';

  // ---------- toast ----------
  let toastEl=null, toastT=null;
  function showToast(msg){
    if(!toastEl){
      toastEl=document.createElement('div');
      toastEl.className='wd-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.style.opacity='1';
    clearTimeout(toastT);
    toastT=setTimeout(()=>{ toastEl.style.opacity='0'; }, 1500);
  }

  // ---------- progress + steps ----------
  const pbar = $('#pbar'), ppct = $('#ppct');
  const TOTAL_STEPS = 5;
  const chips = $$('[data-step-chip]');

  function updateStepProgress(step){
    const pct=Math.round(((step-1)/(TOTAL_STEPS-1))*100);
    pbar.classList.remove('anim'); void pbar.offsetWidth; pbar.classList.add('anim');
    pbar.style.width=pct+'%';
    ppct.textContent=pct;
  }

  function setStep(n){
    $$('[data-step]').forEach(el=>{
      const active = el.getAttribute('data-step')==n;
      el.hidden = !active;
      el.setAttribute('aria-hidden', String(!active));
    });
    chips.forEach(c=> c.classList.toggle('active', c.getAttribute('data-step-chip')==n));
    updateStepProgress(+n);
    if(+n === 4){
      $('#calc').disabled = !validateProfile();
    }
  }

  // ---------- tooltip (info icons) ----------
  let tipEl=null, tipTarget=null;
  function ensureTip(){
    if(!tipEl){
      tipEl=document.createElement('div');
      tipEl.className='wd-tip';
      tipEl.setAttribute('role','tooltip');
      document.body.appendChild(tipEl);
    }
  }
  function positionTip(target){
    if(!tipEl) return;
    const r = target.getBoundingClientRect();
    let left = r.left + r.width/2;
    const top = r.top - 10;
    const minL = 10, maxL = window.innerWidth - 10;
    left = Math.max(minL, Math.min(maxL, left));
    tipEl.style.left = left + 'px';
    tipEl.style.top = top + 'px';
    tipEl.style.transform = 'translate(-50%,-100%)';
    tipEl.style.display='block';
  }
  function hideTip(){
    if(tipEl) tipEl.style.display='none';
    if(tipTarget) tipTarget=null;
  }
  document.addEventListener('click', hideTip);
  $$('.info').forEach(el=>{
    el.setAttribute('role','button');
    el.setAttribute('tabindex','0');
    el.setAttribute('aria-expanded','false');
    const toggle = ()=>{
      if(tipTarget === el){ hideTip(); return; }
      $$('.info[data-tip-active]').forEach(o=>{
        o.removeAttribute('data-tip-active');
        o.setAttribute('aria-expanded','false');
      });
      el.setAttribute('data-tip-active','');
      el.setAttribute('aria-expanded','true');
      ensureTip();
      tipTarget = el;
      tipEl.textContent = el.getAttribute('data-tip') || '';
      positionTip(el);
    };
    el.addEventListener('click', (e)=>{ e.stopPropagation(); toggle(); });
    el.addEventListener('keydown', (e)=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); }});
  });
  window.addEventListener('scroll', ()=>{ if(tipTarget) positionTip(tipTarget); }, {passive:true});
  window.addEventListener('resize', ()=>{ if(tipTarget) positionTip(tipTarget); });

  // ---------- validation ----------
  const limits = {
    age:    {min:10, max:90,  label:()=> t('age')},
    height: {min:120,max:220, label:()=> t('height')},
    weight: {min:35, max:160, label:()=> t('weight')}
  };
  function clearFieldError(id){
    const input = $(`#${id}`);
    const msgEl = $(`#${id}-msg`);
    input.classList.remove('invalid');
    if(msgEl){ msgEl.classList.remove('show'); msgEl.textContent=''; }
  }
  function showFieldError(id, message){
    const input = $(`#${id}`);
    const msgEl = $(`#${id}-msg`);
    input.classList.add('invalid');
    if(msgEl){ msgEl.innerHTML = message; msgEl.classList.add('show'); }
  }
  function validateField(id){
    const v = +$(`#${id}`).value;
    const {min,max,label} = limits[id];
    if(!v && v!==0){ showFieldError(id, t('required',{label:label()})); return false; }
    if(v < min || v > max){ showFieldError(id, t('between',{label:label(),min,max})); return false; }
    clearFieldError(id); return true;
  }
  function validateProfile(){
    const ids = ['age','height','weight'];
    let firstInvalid = null;
    ids.forEach(id=>{ if(!validateField(id)) firstInvalid = firstInvalid || id; });
    if(firstInvalid){
      $(`#${firstInvalid}`).scrollIntoView({behavior:'smooth', block:'center'});
      $(`#${firstInvalid}`).focus({preventScroll:true});
      return false;
    }
    return true;
  }
  ;['age','height','weight'].forEach(id=>{
    const el = $(`#${id}`);
    const syncCalc = ()=>{
      if(!$('[data-step="4"]').hidden){
        $('#calc').disabled = !validateProfile();
      }
    };
    el.addEventListener('input', ()=>{ clearFieldError(id); syncCalc(); });
    el.addEventListener('blur', ()=>{ validateField(id); syncCalc(); });
  });

  // ---------- nav handlers ----------
  const app = $('#app');
  app.addEventListener('click', (e)=>{
    const back=e.target.closest('[data-back]');
    if(back){ setStep(back.getAttribute('data-back')); return; }
    if(e.target.closest('#next1')){
      if(!validateProfile()) return;
      setStep(2); return;
    }
    const next=e.target.closest('[data-next]');
    if(next){ setStep(next.getAttribute('data-next')); }
  });

  // ---------- reset ----------
  function resetAll(){
    $('#name').value='';
    $('#sex').value='male';
    ['age','height','weight'].forEach(id=>{ const el=$(`#${id}`); el.value=''; clearFieldError(id); });
    ['pull','dips','sqkg','hs','mu'].forEach(id=>{
      const e=$(`#${id}`); e.value=0; e.dispatchEvent(new Event('input',{bubbles:true}));
    });
    $('#core').value='0';
    $('#toes').value='no';
    $('#hands').value='no';
    $('#lower').value='atg';
    $('#prods').innerHTML='';
    $('#suggest').innerHTML='';
    $('#mycode').value='';
    const grid=$('#cmpgrid'); grid.style.display='none'; grid.innerHTML='';
    $('#avggrid').innerHTML=''; $('#avgcomment').textContent='';
    $('#wd-badge').style.display='none';
    window.lastResult = null;
    hideTip();
    setStep(1);
        hideTip();
    setStep(1);

    // NEW: visually reset the gauge
    const pctNode = document.getElementById('wd-pct');
    if (pctNode) pctNode.textContent = '0%';
    if (window.wdGaugeSet) window.wdGaugeSet(0);

  }
  $('#reset').addEventListener('click', resetAll);

  // ---------- readouts & squat % ----------
  function bindRange(id,out){
    const e=$(`#${id}`), o=$(`#${out}`);
    const sync=()=> o.textContent=(e.value||'0');
    e.addEventListener('input', sync);
    sync();
  }
  bindRange('pull','v-pull');
  bindRange('dips','v-dips');
  bindRange('hs','v-hs');
  bindRange('mu','v-mu');

  function bindSquatPct(){
  const el = $('#sqkg');
  const weightEl = $('#weight');
  const kg = $('#v-sqkg');

  if(!el || !weightEl){ return; }

  const sync = () => {
    if (kg) kg.textContent = el.value || '0';
    // IMPORTANT: query v-sqpct each time because applyLanguage() recreates it
    const pctEl = document.querySelector('#v-sqpct');
    if (!pctEl) return; // span not in DOM yet
    const bw = +weightEl.value || 0;
    pctEl.textContent = bw ? Math.round((+el.value / bw) * 100) : 0;
  };

  // Avoid stacking multiple listeners if this is called more than once
  el._wdSqSync && el.removeEventListener('input', el._wdSqSync);
  weightEl._wdSqSync && weightEl.removeEventListener('input', weightEl._wdSqSync);

  el._wdSqSync = sync;
  weightEl._wdSqSync = sync;

  el.addEventListener('input', sync, { passive: true });
  weightEl.addEventListener('input', sync, { passive: true });

  // initial paint
  sync();
}

  // ---------- slider guardrails + simple comments ----------
  const notes = {
    pull: $('#guard-pull'),
    dips: $('#guard-dips'),
    sqkg: $('#guard-sqkg'),
    hs:   $('#guard-hs'),
    mu:   $('#guard-mu')
  };
  function showNote(id, text){
    const n=notes[id]; if(!n) return;
    n.textContent=text; n.classList.add('show');
    clearTimeout(n._t); n._t=setTimeout(()=>n.classList.remove('show'), 2000);
  }
  const pullEl=$('#pull'), muEl=$('#mu'), dipsEl=$('#dips'), sqEl=$('#sqkg'), weightEl=$('#weight');

  function guardMu(){
    const pull = +pullEl.value||0;
    if(+muEl.value > pull){
      muEl.value = pull;
      muEl.dispatchEvent(new Event('input',{bubbles:true}));
      showNote('mu',t('note_mu_cap'));
      try{ showToast(t('toast_mu_cap')); }catch{}
    }
  }
  muEl.addEventListener('input', guardMu);
  pullEl.addEventListener('input', guardMu);

  function guardDips(){
    const p=+pullEl.value||0, d=+dipsEl.value||0;
    if(p>20 && d < p*0.4){ showNote('dips',t('note_dips_gap')); }
    if(d>20 && p < d*0.4){ showNote('dips',t('note_pullup_gap')); }
  }
  dipsEl.addEventListener('input', guardDips);
  pullEl.addEventListener('input', guardDips);

  function guardSquat(){
    const bw=+weightEl.value||0; if(!bw) return;
    const cap = Math.round(bw*3.5);
    if(+sqEl.value > cap){
      sqEl.value = cap;
      sqEl.dispatchEvent(new Event('input',{bubbles:true}));
      showNote('sqkg',t('note_sq_cap',{cap}));
      try{ showToast(t('toast_sq_cap',{cap})); }catch{}
    }
  }
  sqEl.addEventListener('input', guardSquat);
  weightEl.addEventListener('input', guardSquat);

  const hsEl=$('#hs');
  hsEl.addEventListener('input', ()=>{
    const v = +hsEl.value||0;
    if(v>=60){ showNote('hs', t('note_hs_60')); }
    else if(v>=45){ showNote('hs', t('note_hs_45')); }
    else if(v>0){
      showNote('hs', lang()==='es' ? 'Sigue: pino en pared y entradas.' : 'Keep going: wall drills & entries.');
    }
  });

  // ---------- compute ----------
  function mWtPull(sex, w){
    if(!w&&w!==0) return 1.00;
    return (sex==='male') ? (w>90?0.97 : w<60?1.03 : 1.00) : (w>75?0.97 : w<50?1.03 : 1.00);
  }
  function mWtLeg(w){
    if(!w&&w!==0) return 1.00;
    return w>90?1.03 : w<60?0.97 : 1.00;
  }

  function sPullScore(n){ return sPull(n); }

  function compute(){
    const sex=$('#sex').value;
    const age=num('age');
    const h=num('height');
    const w=num('weight');
    const pull=num('pull');
    const dips=num('dips');
    const sqkg=num('sqkg');
    const sqpct=w? (sqkg/w*100) : 0;
    const core=num('core');
    const hs=num('hs');
    const toes=$('#toes').value;
    const hands=$('#hands').value;
    const lower=$('#lower').value;
    const mu=num('mu');

    const sexUpper = (sex==='female') ? 1.10 : 1.00; // upper body only
    const htSkill  = (h && h<165) ? 1.03 : ((h && h>185) ? 0.97 : 1.00); // skills

    const pullAdj = sPull(pull) * sexUpper * mWtPull(sex,w);
    const dipsAdj = sDips(dips) * sexUpper;
    const sqAdj   = sSq(sqpct) * mWtLeg(w);
    const coreAdj = core * htSkill;
    const hsAdj   = sHS(hs) * htSkill;

    const stAvg = (pullAdj + dipsAdj + sqAdj + coreAdj) / 4; // 0..5
    const balW  = (hsAdj*0.4 + sLB(lower)*0.4 + yesNo(toes)*0.1 + yesNo(hands)*0.1); // 0..5
    const expN  = (sMU(mu)/3)*5; // 0..5

    let base = stAvg*0.8 + balW*0.1 + expN*0.1; // 0..5
    base *= mAge(age);
    base = Math.min(5, base);

    let pct=Math.round((base/5)*100);

    const skillFrac = ((hsAdj/5)*0.6 + (sLB(lower)/5)*0.4); // 0..1
    const mobFlags = (toes==='yes') + (hands==='yes'); // 0..2
    if(skillFrac < 0.25 || mobFlags === 0) pct = Math.min(pct, 85);
    else if(skillFrac < 0.40 || mobFlags === 1) pct = Math.min(pct, 90);
    pct = clamp(pct, 0, 100);

    const cats=[{k:'Strength',v:stAvg*0.8},{k:'Balance',v:balW*0.1},{k:'Explosive',v:expN*0.1}].sort((a,b)=>a.v-b.v);
    const catMap = { Strength: t('sec_strength'), Balance: t('sec_balance'), Explosive: t('sec_explosive') };

    return {
      pct,
      final:+base.toFixed(2),
      weakest:(cats[0] && catMap[cats[0].k]) || t('sec_strength'),
      parts:{
        pull:sPull(pull), dips:sDips(dips), sq:sSq(sqpct), core,
        hs:sHS(hs), lb:sLB(lower), toes:yesNo(toes), hands:yesNo(hands), mu:sMU(mu)
      },
      raw:{pull,dips,sqpct,hs,core,mu,toes,hands}
    };
  }

  // ---------- tips (localized, tailored) ----------
  function tips(d){
    const tps = t('tips');
    const tlines=[];
    const {pull,dips,sqpct,hs,core,mu,toes,hands} = d.raw;

    // Weakest category–focused
    if(d.weakest === t('sec_strength')){
      if(d.parts.pull<2) tlines.push(tps.pull_easy);
      if(d.parts.dips<2) tlines.push(tps.dips_sets);
      if(d.parts.core<3) tlines.push(tps.core_ladder);
    } else if (d.weakest.indexOf(t('sec_balance').split(' ')[0]) === 0) {
  // Handstand progression based on raw seconds
  if (hs < 20) {
    tlines.push(tps.hs_daily);                  // beginners: wall + entries
  } else if (hs < 45) {
    tlines.push(t('note_hs_45'));               // practice tuck & straddle
  } else {
    tlines.push(t('note_hs_60'));               // one-arm HS prep
  }

  // Only recommend pistol regressions if lower-body mobility is actually weak (ATG only)
  if (d.parts.lb < 3) tlines.push(I18N.en.tips.lb_pistol);
    } else {
      // Muscle-up tips only if pull-ups > 15
      if(pull > 15){
        if(d.parts.mu<2) tlines.push(tps.mu_band);
        else tlines.push(tps.mu_timing);
      }
    }

    // General builders
    if(dips < 10) tlines.push(tps.dips_push);
    else if(dips < 20) tlines.push(tps.dips_weight);

    if(pull < 10) tlines.push(tps.pull_rows);
    else if(pull < 15) tlines.push(tps.pull_grips);
    else if(pull < 20) tlines.push(tps.pull_weighted);

    if(sqpct < 70) tlines.push(tps.sq_block);

    // Mobility/stretching: ALWAYS English
    if(toes !== 'yes') tlines.push(I18N.en.tips.toe_prog);
    if(hands !== 'yes') tlines.push(I18N.en.tips.shoulder_mob);

    if(String(core) === '1') tlines.push(tps.core_upgrade);
    if(hs === 0) tlines.push(tps.hs_zero);

    // Additional MU tips only if pull-ups > 15
    if(pull > 15){
      if(mu === 0) tlines.push(tps.mu_zero);
      else if(mu === 5) tlines.push(tps.mu_five);
    }

    if(!tlines.length){ tlines.push(tps.fallback1, tps.fallback2, tps.fallback3); }
    const unique = [...new Set(tlines)].slice(0,6);
    return `<strong>${t('next_steps')}</strong><ul style="margin:6px 0 0 18px">${unique.map(x=>`<li>${x}</li>`).join('')}</ul>`;
  }

  // ---------- Products (icons + lists) ----------
  const ICON_URLS = {
    workout_rings: "https://cdn.shopify.com/s/files/1/0900/8847/2955/files/workout_rings_150.png?v=1755163332",
    ankle_straps:  "https://cdn.shopify.com/s/files/1/0900/8847/2955/files/ankle_straps_150.png?v=1755163332",
    parallettes:   "https://cdn.shopify.com/s/files/1/0900/8847/2955/files/parallettes_150.png?v=1755163332",
    elastic_bands: "https://cdn.shopify.com/s/files/1/0900/8847/2955/files/elastic_bands_150.png?v=1755163332",
    dip_belt:      "https://cdn.shopify.com/s/files/1/0900/8847/2955/files/dip_belt_150.png?v=1755163332",
    jump_rope:     "https://cdn.shopify.com/s/files/1/0900/8847/2955/files/jump_rope_150.png?v=1755163332",
    elbow_sleeves: "https://cdn.shopify.com/s/files/1/0900/8847/2955/files/elbow_sleeves_150.png?v=1755163331",
    wrist_wraps:   "https://cdn.shopify.com/s/files/1/0900/8847/2955/files/wrist_wraps_150.png?v=1755163332",
    magnisum:      "https://cdn.shopify.com/s/files/1/0900/8847/2955/files/magnisum_150.png?v=1755163331"
  };
  const PRODS = {
      elbow_sleeves:{title:'Elbow sleeve', href:'https://www.wilddynamics.eu/products/elbow-sleeve', key:'elbow_sleeves'},
      dip_belt:{title:'Dip Belt', href:'https://www.wilddynamics.eu/products/dip-belt', key:'dip_belt'},
      parallettes:{title:'Parallettes', href:'https://www.wilddynamics.eu/products/wild-parallettes', key:'parallettes'},
      workout_rings:{title:'Workout Rings', href:'https://www.wilddynamics.eu/products/gymnastic-rings', key:'workout_rings'},
      elastic_bands:{title:'Resistance Bands', href:'https://www.wilddynamics.eu/products/resistance-bands', key:'elastic_bands'},
      wrist_wraps:{title:'Wrist Wraps', href:'https://www.wilddynamics.eu/products/wrist-wraps', key:'wrist_wraps'},
      jump_rope:{title:'Jump Rope', href:'https://www.wilddynamics.eu/products/jump-ropes', key:'jump_rope'},
      magnisum:{title:'Liquid Chalk', href:'https://www.wilddynamics.eu/products/liquid-chalk-250ml', key:'magnisum'},
  };

  function mapWeakKey(localizedWeakest){
    if(localizedWeakest === t('sec_explosive')) return 'Explosive';
    if(localizedWeakest === t('sec_strength'))  return 'Strength';
    return 'Balance';
  }
  function recommendProducts(data) {
    const recs = [];

    // 1. Pull-ups
    if (data.pull < 10) {
      recs.push("elbow_sleeves");
    } else if (data.pull > 20) {
      recs.push("dip_belt");
    }

    // 2. Stretching / mobility
    if (data.toes === "no" || data.hands === "no") {
      recs.push("elastic_bands");
    }

    // 3. Push strength
    if (data.dips < 10) {
      recs.push("parallettes");
    }

    // 4. Handstand
    if (data.hs < 10) {
      recs.push("parallettes");
      recs.push("wrist_wraps");
    }

    // 5. Muscle ups
    if (data.mu < 5) {
      recs.push("elastic_bands");
      recs.push("magnisum"); // liquid chalk
    }

    // 6. Beginner
    if (data.pull < 5 && data.dips < 5) {
      recs.push("jump_rope");
      recs.push("elastic_bands");
    }

    // 7. Advanced
    if (data.pull > 20 && data.dips > 20) {
      recs.push("workout_rings");
    }

    // 8. Lower body
    if (data.lb < 3) {
      recs.push("ankle_straps");
    }
    console.log(recs);
    // dedupe (in case of duplicates)
    const seen = new Set();
    return recs.filter(p => {
      if (!p || seen.has(p)) return false;
      seen.add(p);
      return true;
    });
  }
  function renderProducts(recs) {
    const wrap=$('#prods');
    wrap.innerHTML='';
    recs.forEach(prod => {
      const src=ICON_URLS[prod]||'';
      const p=PRODS[prod];
      const el = document.createElement('div');
      el.className = 'prod';
      el.innerHTML = `<div class="icon">${src? `<img src="${src}" alt="${p.title}" loading="lazy">` : ''}</div>
        <div style="flex:1">
           <h4 title="${p.title}">${p.title}</h4>
           <a class="btn btn-primary" style="padding:6px 10px" href="${p.href}" target="_blank" rel="noopener">${t('view')}</a>
        </div>`;

      wrap.appendChild(el)
    });
  }
  // function renderProducts(recs){
  //   const wrap=$('#prods');
  //   wrap.innerHTML='';
  //   if(d.parts.pull < 10) {
  //     const el=document.createElement('div');
  //     el.className='prod';
  //     key = "elbow_sleeves";
  //     const src=ICON_URLS[key]||'';
  //     el.innerHTML =
  //       `<div class="icon">${src? `<img src="${src}" alt="${p.title}" loading="lazy">` : ''}</div>
  //        <div style="flex:1">
  //          <h4 title="${p.title}">${p.title}</h4>
  //          <a class="btn btn-primary" style="padding:6px 10px" href="${p.href}" target="_blank" rel="noopener">${t('view')}</a>
  //        </div>`;
  //     wrap.appendChild(el);
  //   } else if(d.parts.pull >= 20) {
  //     const el=document.createElement('div');
  //     el.className='prod';
  //     key = "dip_belt";
  //     const src=ICON_URLS[key]||'';
  //     el.innerHTML =
  //       `<div class="icon">${src? `<img src="${src}" alt="${p.title}" loading="lazy">` : ''}</div>
  //        <div style="flex:1">
  //          <h4 title="${p.title}">${p.title}</h4>
  //          <a class="btn btn-primary" style="padding:6px 10px" href="${p.href}" target="_blank" rel="noopener">${t('view')}</a>
  //        </div>`;
  //     wrap.appendChild(el);
  //   }
  //   (PRODS[weakKey]||PRODS.Strength).forEach(p=>{
  //     const el=document.createElement('div');
  //     el.className='prod';
  //     const src=ICON_URLS[p.key]||'';
  //     el.innerHTML =
  //       `<div class="icon">${src? `<img src="${src}" alt="${p.title}" loading="lazy">` : ''}</div>
  //        <div style="flex:1">
  //          <h4 title="${p.title}">${p.title}</h4>
  //          <a class="btn btn-primary" style="padding:6px 10px" href="${p.href}" target="_blank" rel="noopener">${t('view')}</a>
  //        </div>`;
  //     wrap.appendChild(el);
  //   });
  // }

  // ---------- Mini gauge + average compare ----------
  function miniGauge(percent,label){
    const C=2*Math.PI*42, dash=(percent/100)*C;
    const col = percent<41? '#ef4444' : (percent<71? '#f59e0b' : '#16a34a');
    return `
      <div style="display:flex;gap:12px;align-items:center">
        <svg viewBox="0 0 120 120" width="120" height="120">
          <circle cx="60" cy="60" r="42" fill="none" stroke="#e5e7eb" stroke-width="12"></circle>
          <circle cx="60" cy="60" r="42" fill="none" stroke="${col}" stroke-width="12" stroke-linecap="round"
                  transform="rotate(-90 0 0)" stroke-dasharray="${dash} ${C-dash}"></circle>
          <text x="60" y="66" text-anchor="middle" font-size="18" font-weight="800" fill="#0f172a">${percent}%</text>
        </svg>
        <div><div style="font-weight:800">${label}</div><div style="color:#64748b;font-size:13px">${t('gauge_caption')}</div></div>
      </div>`;
  }
  function parseFriendInput(str){
    const raw = (str||'').trim(); if(!raw) return null;
    const codeMatch = raw.match(/WD-(\d{1,3})/i);
    if(codeMatch){
      const pct = clamp(parseInt(codeMatch[1],10),0,100);
      const name = raw.replace(codeMatch[0],'').replace(/[\s–—\-|:()]+/g,' ').trim();
      return { pct, name: name || null };
    }
    const numMatch = raw.match(/\b(\d{1,3})\b/);
    if(numMatch){
      const pct = clamp(parseInt(numMatch[1],10),0,100);
      const name = raw.replace(numMatch[0],'').replace(/[%\s–—\-|:()]+/g,' ').trim();
      return { pct, name: name || null };
    }
    return null;
  }
  function avgPct(sex, age){
    let base = sex==='female'?34:38;
    if(age>=50) base -= 6;
    else if(age>=40) base -= 4;
    else if(age>=30) base -= 2;
    else if(age<=20) base += 2;
    return clamp(base, 22, 55);
  }
  function rerenderAverage(d){
    const sex=$('#sex').value;
    const age=num('age');
    const avg = avgPct(sex, age);
    const avggrid=$('#avggrid');
    const myName = ($('#name').value || '').trim().replace(/\s+/g,' ').slice(0,60);
    const youLabel = myName || t('you');
    avggrid.innerHTML = miniGauge(d.pct, youLabel) + miniGauge(avg, t('average'));
    const delta = d.pct - avg;
    const msg = delta>=0 ? t('above_avg',{delta}) : t('below_avg',{delta:Math.abs(delta)});
    $('#avgcomment').textContent = msg;
  }

// ---------- gauge animation ----------
const easeOutCubic = t0 => 1 - Math.pow(1 - t0, 3);
function updateGauge(percent){
  const arc = document.getElementById('wd-arc');
  const pctEl = document.getElementById('wd-pct');
  const lvlEl = document.getElementById('wd-lvl');
  if (!arc || !pctEl || !lvlEl) return;

  const pTarget = Math.max(0, Math.min(100, percent|0));

  const C = arc.getTotalLength
    ? arc.getTotalLength()
    : (2 * Math.PI * (+arc.getAttribute('r') || 90));

  // start from empty
  arc.style.strokeDasharray  = C;
  arc.style.strokeDashoffset = C;

  // force layout, then animate
  void arc.getBoundingClientRect();

  const targetOffset = C * (1 - pTarget/100);
  const dur = 900;
  const t0 = performance.now();

  function step(ti){
    const k = Math.min(1, (ti - t0) / dur);
    const eased  = easeOutCubic(k);
    const offset = C + (targetOffset - C) * eased;
    arc.style.strokeDashoffset = offset;

    const shown = Math.round((1 - offset / C) * 100);
    pctEl.textContent = Math.max(0, Math.min(100, shown)) + '%';

    if (k < 1){
      requestAnimationFrame(step);
    } else {
      arc.style.strokeDashoffset = targetOffset;
      pctEl.textContent = pTarget + '%';
      lvlEl.textContent = levelName(pTarget);
    }
  }
  requestAnimationFrame(step);
}


  // ---------- share image ----------
  function buildResultCanvas(d){
    const myName = ($('#name').value || '').trim().replace(/\s+/g,' ').slice(0,60);
    const mycode = $('#mycode').value || '';
    const w=1080,h=1350; // portrait
    const c=document.createElement('canvas'); c.width=w; c.height=h;
    const ctx=c.getContext('2d');

    // Background gradient + circles
    const g=ctx.createLinearGradient(0,0,0,h);
    g.addColorStop(0,'#ffffff'); g.addColorStop(1,'#ffe9e4');
    ctx.fillStyle=g; ctx.fillRect(0,0,w,h);
    ctx.globalAlpha=0.12; ctx.fillStyle='#e33d20';
    for(let i=0;i<6;i++){ ctx.beginPath(); ctx.arc(160+i*170, 140+i*70, 220-i*18, 0, Math.PI*2); ctx.fill(); }
    ctx.globalAlpha=1;

    // Header
    ctx.fillStyle='#0f172a'; ctx.font='48px Arial'; ctx.fillText('Wild Dynamics',60,100);
    ctx.font='36px Arial'; ctx.fillStyle='#334155';
    ctx.fillText(lang()==='es'?'Nivel de Calistenia':'Calisthenics Level',60,160);

    // Big % + level + badge
    const levelText = levelName(d.pct);
    const badge = badgeFor(d.pct);
    ctx.font='bold 200px Arial';
    ctx.fillStyle='#e33d20';
    ctx.fillText(`${d.pct}%`,60,360);
    ctx.font='bold 90px Arial'; ctx.fillStyle='#0f172a'; ctx.fillText(levelText,60,460);
    ctx.font='36px Arial'; ctx.fillStyle='#9a3412'; ctx.fillText(`${badge.emoji} ${badge.label}`,60,510);

    // Code + name + date
    ctx.font='30px Arial'; ctx.fillStyle='#475569';
    let y=560;
    if(myName){ ctx.fillText((lang()==='es'?'Nombre: ':'Name: ') + myName,60,y); y+=40; }
    ctx.fillText((lang()==='es'?'Código: ':'Code: ') + mycode,60,y); y+=40;
    const today = new Date();
    const dateStr = today.toLocaleDateString(lang()==='es'?'es-ES':undefined,{year:'numeric', month:'short', day:'numeric'});
    ctx.fillText((lang()==='es'?'Fecha: ':'Date: ') + dateStr,60,y);

    // Footer
    ctx.font='28px Arial'; ctx.fillStyle='#475569';
    ctx.fillText('wilddynamics.com',60,h-60);
    return c;
  }

  // ---------- language wiring (DOM text replacement) ----------
function applyLanguage(){
  // tiny safe setter so we never crash if an element is missing
  const setText = (sel, val) => { const el = document.querySelector(sel); if(el) el.textContent = val; };
  const setHTML = (sel, val) => { const el = document.querySelector(sel); if(el) el.innerHTML = val; };
  const setAttr = (sel, attr, val) => { const el = document.querySelector(sel); if(el) el.setAttribute(attr, val); };

  // Top bar
  setText('#t-title', t('title'));
  setText('#t-sub', t('sub'));
  setText('#t-language-label', t('language'));
  setText('#t-reset', t('reset'));

  // Step chips
  const steps = t('steps') || [];
  setText('#t-step1', steps[0] || '');
  setText('#t-step2', steps[1] || '');
  setText('#t-step3', steps[2] || '');
  setText('#t-step4', steps[3] || '');
  setText('#t-step5', steps[4] || '');

  // Step 1 — Profile
  setText('#t-sec-profile', t('sec_profile'));
  setText('#t-name', t('name'));
  setText('#t-sex', t('sex'));
  setText('#t-sex-male', t('male'));      // <-- updates Male → Hombre
  setText('#t-sex-female', t('female'));  // <-- updates Female → Mujer
  setText('#t-age', t('age'));
  setText('#t-height', t('height'));
  setText('#t-weight', t('weight'));
  setText('#t-tips-title', t('tips_title'));
  setHTML('#t-tips-sub', t('tips_sub'));
  setHTML('#t-tips-sex', t('tips_sex'));
  setText('#t-back1', t('back'));
  setText('#t-next', t('next'));

  // Step 2 — Strength
  setText('#t-sec-strength', t('sec_strength'));
  setText('#t-pullups', t('pullups'));
  setText('#t-dips', t('dips'));
  setText('#t-sq3rm', t('sq3rm'));
  setHTML('#t-sqpct', t('sqpct_label'));
  setText('#t-core', t('core'));
  setAttr('#t-core-tip', 'data-tip', t('core_tip'));
  const coreOpts = t('core_opts') || [];
  setText('#t-core-none', coreOpts[0] || '');
  setText('#t-core-lsit', coreOpts[1] || '');
  setText('#t-core-dragonflag', coreOpts[2] || '');
  setText('#t-core-frontlever', coreOpts[3] || '');
  setText('#t-core-planche', coreOpts[4] || '');
  setText('#t-core-oafl', coreOpts[5] || '');
  setText('#t-back2', t('back'));
  setText('#t-next2', t('next'));

  // Step 3 — Balance & Mobility
  setText('#t-sec-balance', t('sec_balance'));
  setText('#t-hs', t('hs'));
  setText('#t-toe-touch', t('toe_touch'));
  setAttr('#t-toe-touch-tip', 'data-tip', t('toe_touch_tip'));
  setText('#t-hbb', t('hbb'));
  setAttr('#t-hbb-tip', 'data-tip', t('hbb_tip'));
  setText('#t-lower', t('lower'));
  setAttr('#t-lower-tip', 'data-tip', t('lower_tip'));
  const lowOpts = t('lower_opts') || [];
  setText('#t-lower-atg', lowOpts[0] || '');
  setText('#t-lower-pistol', lowOpts[1] || '');
  setText('#t-lower-dragon', lowOpts[2] || '');
  setText('#t-yes', t('yes'));
  setText('#t-no', t('no'));
  setText('#t-yes2', t('yes'));
  setText('#t-no2', t('no'));
  setText('#t-back3', t('back'));
  setText('#t-next3', t('next'));

  // Step 4 — Explosive
  setText('#t-sec-explosive', t('sec_explosive'));
  setText('#t-mu', t('mu'));
  setText('#t-back4', t('back'));
  setText('#t-see-result', t('see_result'));

  // Step 5 — Result
  setText('#t-avg-title', t('avg_title'));
  setText('#t-reco', t('reco'));
  setText('#t-your-code', t('your_code'));
  setText('#t-copy', t('copy'));
  setText('#t-compare', t('compare'));
  const friend = document.querySelector('#friend');
  if (friend) friend.placeholder = t('friend_ph');
  const shareBtn = document.querySelector('#simple-share');
  if (shareBtn) shareBtn.textContent = t('share_btn');
  // (Removed #t-back5 line to avoid errors — that element doesn’t exist)

  // If a result already exists, re-localize dynamic bits
  if (window.lastResult){
    const pctText = parseInt((document.querySelector('#wd-pct')?.textContent || '0').replace('%',''), 10);
    const lvlEl = document.querySelector('#wd-lvl');
    if (lvlEl) lvlEl.textContent = levelName(isFinite(pctText) ? pctText : window.lastResult.pct);
        // Re-apply gauge fill after relabeling
    if (window.wdGaugeSet) window.wdGaugeSet(window.lastResult.pct);


    const badge = badgeFor(window.lastResult.pct);
    const badgeEl = document.querySelector('#wd-badge');
    if (badgeEl){
      badgeEl.textContent = `${badge.emoji} ${badge.label}`;
      badgeEl.style.display = 'inline-flex';
    }

    // Rebuild tips and comparison with current language
    const sug = document.querySelector('#suggest');
    if (sug) sug.innerHTML = (typeof tips === 'function') ? tips(window.lastResult) : '';
    if (typeof rerenderAverage === 'function') rerenderAverage(window.lastResult);

    // Rebuild product cards
    if (typeof recommendProducts === 'function' && typeof renderProducts === 'function'){
      const recs = recommendProducts(window.lastResult.raw);
      renderProducts(recs);
    }
  }
}
  // ---------- calculate + result ----------
  $('#calc').addEventListener('click', ()=>{
    if(!validateProfile()){ setStep(1); return; }
    const d=compute();
    window.lastResult = d;
    setStep(5);
    updateGauge(d.pct);

    $('#suggest').innerHTML = tips(d);

    const badge = badgeFor(d.pct);
    const badgeEl = $('#wd-badge');
    badgeEl.textContent = `${badge.emoji} ${badge.label}`;
    badgeEl.style.display='inline-flex';

    const myName = ($('#name').value || '').trim().replace(/\s+/g,' ').slice(0,60);
    const mycode=$('#mycode'), copy=$('#copycode');
    mycode.value = myName ? `WD-${d.pct} — ${myName}` : `WD-${d.pct}`;
    copy.onclick = async ()=>{
      try{
        await navigator.clipboard.writeText(mycode.value);
        copy.textContent = t('copied');
        setTimeout(()=>copy.textContent= t('copy'), 1000);
      }catch{
        mycode.select();
        alert(t('copied_manual'));
      }
    };

    rerenderAverage(d);
    const recs = recommendProducts(d.raw);
    renderProducts(recs);

    const friend=$('#friend'), cmp=$('#cmp'), grid=$('#cmpgrid');
    cmp.onclick=()=>{
      const parsed = parseFriendInput(friend.value);
      if(!parsed || !Number.isFinite(parsed.pct)){
        alert(lang()==='es'
          ? 'Introduce un código como WD-87 — Sam, o un porcentaje 0–100 (opcional con nombre).'
          : 'Enter a code like WD-87 — Sam, or a percent 0–100 (optionally with a name).');
        return;
      }
      const youLabel = myName || t('you');
      const friendLabel = parsed.name || t('friend_label');
      grid.style.display='grid';
      grid.style.gridTemplateColumns='repeat(auto-fit,minmax(260px,1fr))';
      grid.style.gap='12px';
      grid.innerHTML = miniGauge(d.pct, youLabel) + miniGauge(parsed.pct, friendLabel);
    };

    const shareBtn = $('#simple-share');
    const shareText = `${badge.emoji} ${badge.label}: ${d.pct}% ${lang()==='es'
      ? 'en el Asistente de Nivel de Calistenia de Wild Dynamics'
      : 'on the Wild Dynamics Calisthenics Wizard'}.${myName?(' — '+myName):''} #calisthenics #streetworkout`;
    shareBtn.onclick = ()=>{
      const canvas = buildResultCanvas(d);
      const a=document.createElement('a');
      a.download='wild-dynamics-result.png';
      a.href=canvas.toDataURL('image/png');
      a.click();
      (async ()=>{
        try{
          await navigator.clipboard.writeText(shareText);
          showToast(t('img_saved_clip'));
        } catch{
          showToast(t('img_saved_manual'));
        }
      })();
    };
  });

  // enter to compare
  $('#friend').addEventListener('keydown', (e)=>{ if(e.key==='Enter'){ $('#cmp').click(); } });

  // language init + switch (persist and stop flipping)
 // autoInitLanguage();
  //applyLanguage();
  // initial step

  function bindLang() {
    const el = document.getElementById('lang');
    if (!el) return;

    // Remove any previous handler to avoid stacking
    el._langHandler && el.removeEventListener('change', el._langHandler, true);

    el._langHandler = function onLangChange(e) {
      // Read ASAP (capture phase) in case other scripts modify it later
      const chosen = this.value;

      // Defer any UI updates / alerts to the next tick
      setTimeout(() => {
        // final value after the browser commits selection
        const finalValue = this.value;
        // Use finalValue for your logic
        setLang(finalValue); applyLanguage(finalValue);
      }, 0);
    };

    // Capture phase to beat other listeners that might revert the value
    el.addEventListener('change', el._langHandler, { capture: true });
  }

  
   // ---------- language init + events ----------
  function bindLang() {
    const el = document.getElementById('lang');
    if (!el) return;

    // Remove any previous handler to avoid stacking
    el._langHandler && el.removeEventListener('change', el._langHandler, true);

    el._langHandler = function onLangChange() {
      // Defer UI updates to next tick so the select's final value is settled
      const finalValue = this.value;
      setTimeout(() => { 
        try { setLang(finalValue); } catch(e){}
        try { applyLanguage(finalValue); } catch(e){}
      }, 0);
    };

    // Capture phase to beat other listeners that might revert the value
    el.addEventListener('change', el._langHandler, { capture: true });
  }

  // ---- Gauge helper (neutral; works with your existing SVG transform) ----
  // Use this anywhere: window.wdGaugeSet( percent )
  window.wdGaugeSet = function(pct){
    var arc = document.getElementById('wd-arc');
    if (!arc) return;

    // Use element radius if present, fallback to 90
    var r = +arc.getAttribute('r') || 90;
    var C;
    try { C = (typeof arc.getTotalLength === 'function') ? arc.getTotalLength() : 2 * Math.PI * r; }
    catch(e){ C = 2 * Math.PI * r; }

    // Cross-browser safe: two values in dasharray
    arc.style.strokeDasharray  = C + ' ' + C;

    var p = Math.max(0, Math.min(100, Number(pct) || 0));
    arc.style.strokeDashoffset = C * (1 - p / 100);
  };

  // ---------- bootstrap ----------
  document.addEventListener('DOMContentLoaded', function(){
    console.log("DOMContentLoaded")
    try { bindLang(); } catch(e){console.log("bindLang", e)}
    try { setStep(1); } catch(e){}              // ensure a visible step
    try { autoInitLanguage(); } catch(e){}
    try { applyLanguage(); } catch(e){}
    try { bindSquatPct(); } catch(e){}          // needs the label injected by applyLanguage
  });

  // Re-bind when Shopify re-renders sections
  document.addEventListener('shopify:section:load', function(){ try { bindLang(); } catch(e){} });
  document.addEventListener('shopify:section:reorder', function(){ try { bindLang(); } catch(e){} });
})();